import React from "react"
import ScrollToTop from "react-scroll-up"

import { Icon } from "@components/icon"

import * as styles from "./scroll-top-button.module.css"

const ScrollTopButton = ({ location }) => {
  // Hide on checkout pages
  const isCheckout = location && location.pathname.startsWith("/checkout")

  if (isCheckout) {
    return null
  }

  return (
    <ScrollToTop
      showUnder={160}
      style={{
        top: `50%`,
        right: `20px`,
        transform: `translateY(-50%)`,
        zIndex: `10`,
        height: `50px`,
      }}
    >
      <div className={styles.scrollTop}>
        <Icon id="arrow-up" width="20" height="25" />
      </div>
    </ScrollToTop>
  )
}

export default ScrollTopButton
